import {Component, OnInit} from '@angular/core';
import {Translation} from '../../models/translation';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  public translation: Translation;
  public isLoggedIn: boolean;


  constructor() { }

  ngOnInit() {
    this.isLoggedIn = sessionStorage.getItem('Token') != null;
    this.translation = JSON.parse(localStorage.getItem('Translation'));
  }

  termsAndConditions() {
    Swal.fire({
      html: '<div style="text-align: left">' +
        '<h2 style="padding-bottom: 40px;">' + this.translation.AgbHeaderPart1 + ' ' + this.translation.AgbHeaderPart2 + '</h2>' +
        '<h3>' + this.translation.Agb1Header + '</h3>' +
        '<p>' + this.translation.Agb1Line1 + '</p>' +
        '<p>' + this.translation.Agb1Line2 + '</p>' +
        '<h3>' + this.translation.Agb2Header + '</h3>' +
        '<p>' + this.translation.Agb2Line1 + '</p>' +
        '<h3>' + this.translation.Agb3Header + '</h3>' +
        '<p>' + this.translation.Agb3Line1 + '</p>' +
        '<h3>' + this.translation.Agb4Header + '</h3>' +
        '<p>' + this.translation.Agb4Line1 + '</p>' +
        '<p>' + this.translation.Agb4Line2 + '</p>' +
        '<p>' + this.translation.Agb4Line3 + '</p>' +
        '<p>' + this.translation.Agb4Line4 + '</p>' +
        '<h4>' + this.translation.Agb41Header + '</h4>' +
        '<p>' + this.translation.Agb41Line1 + '</p>' +
        '<p>' + this.translation.Agb41Line2 + '</p>' +
        '<h4>' + this.translation.Agb42Header + '</h4>' +
        '<p>' + this.translation.Agb42Line1 + '</p>' +
        '<h4>' + this.translation.Agb43Header + '</h4>' +
        '<p>' + this.translation.Agb43Line1 + '</p>' +
        '<h3>' + this.translation.Agb5Header + '</h3>' +
        '<p>' + this.translation.Agb5Line1 + '</p>' +
        '<h4>' + this.translation.Agb51Header + '</h4>' +
        '<p>' + this.translation.Agb51Line1 + '</p>' +
        '<p>' + this.translation.Agb51Line2 + '</p>' +
        '<h4>' + this.translation.Agb52Header + '</h4>' +
        '<p>' + this.translation.Agb52Line1 + '</p>' +
        '<h3>' + this.translation.Agb6Header + '</h3>' +
        '<p>' + this.translation.Agb6Line1 + '</p>' +
        '<h3>' + this.translation.Agb7Header + '</h3>' +
        '<p>' + this.translation.Agb7Line1 + '</p>' +
        '<h3>' + this.translation.Agb8Header + '</h3>' +
        '<p>' + this.translation.Agb8Line1 + '</p>' +
        '<p>' + this.translation.Agb8Line2 + '</p>' +
        '</div>',
      showConfirmButton: true,
      showCloseButton: true,
      allowOutsideClick: true,
      confirmButtonText: 'Ok',
      confirmButtonColor: '#CC0000',
      width: 1100,
    });
  }
}
